import React from 'react'

function Jubileusz() {
  return (
    <div>Jubileusz</div>
  )
}

export default Jubileusz